import iziToast from 'izitoast'

export default {
  validators: {
  },
  data () {
    return {
      submitting: false,
      formErrors: {},
      formData: {}
    }
  },
  computed: {
    message () {
      return 'Zapisano dane'
    }
  },
  methods: {
    prepareData () {
      return this.formData
    },
    submit (data) {
      throw new Error('Function submit must be overroded')
    },
    onSuccess (data) {
      this.$emit('success', data)
      iziToast.show({
        message: this.message,
        color: 'green'
      })
      return data
    },
    onError (data) {
      if (data.response.status === 400) {
        this.formErrors = data.response.data
        this.$validate()
      }
      return data
    },
    onFinally () {
      this.submitting = false
    },
    onSubmit () {
      this.$validate().then(success => {
        if (success) {
          this.submitting = true
          let data = this.prepareData()
          let promise = this.submit(data)
          promise.then(this.onSuccess, this.onError).finally(this.onFinally)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/formMixin.js